// B-136 — a table's page, back to the first whenever `clave` (what the table shows) changes —
// decided while rendering, not in an effect, which could land after a click on "next" and undo it.
import { useState } from "react";

export function usePaginaPorClave(clave) {
  const [estado, setEstado] = useState({ clave, pagina: 1 });
  const pagina = estado.clave === clave ? estado.pagina : 1;
  return [pagina, (p) => setEstado({ clave, pagina: p })];
}

export default usePaginaPorClave;
